import strFunc from "@/lib/lyg/string";

function StudyTitleAswer(props: any) {
  let myProps = {
    info: {},
    daily_info: {},
    state_sort:"main",// main, sub
    ...props
  };
  let info = myProps.info;
  let textbook_info: any = null;
  let textbook_use_info: any = null;
  let text_book_seq=myProps.daily_info["a_textbook_seq"];
  if(myProps.state_sort=="main"){
    text_book_seq=myProps.daily_info["a_textbook_seq"];
  }else if(myProps.state_sort=="sub"){
    text_book_seq=myProps.daily_info["a_subtextbook_seq"];
  }

  if(myProps.state_sort=="main"){
    if (myProps.daily_info["textbook_use"]) {
      textbook_use_info = myProps.daily_info["textbook_use"];
    }
  }else if(myProps.state_sort=="sub"){
    if (myProps.daily_info["subtextbook_use"]) {
      textbook_use_info = myProps.daily_info["subtextbook_use"];
    }
  }

  if (text_book_seq&&myProps.info["daily_textbook_arr"] && myProps.info["daily_textbook_arr"].length > 0) {
    for (let i = 0; i < myProps.info["daily_textbook_arr"].length; i++) {
      if (myProps.info["daily_textbook_arr"][i]["a_seq"] == text_book_seq) {
        textbook_info = myProps.info["daily_textbook_arr"][i];
      }
    }
  }
  if (text_book_seq&&myProps.info["daily_study_title_arr"] && myProps.info["daily_study_title_arr"].length > 0) {
    for (let i = 0; i < myProps.info["daily_study_title_arr"].length; i++) {
      if (myProps.info["daily_study_title_arr"][i]["a_seq"] == text_book_seq) {
        textbook_info = myProps.info["daily_study_title_arr"][i];
      }
    }
  }

  let a_book_pdf_url = "";
  let use_page_num = 1;
  if (textbook_info && textbook_info["a_book_pdf_url"]) {
    a_book_pdf_url = textbook_info["a_book_pdf_url"];
  }
  if (textbook_use_info && textbook_use_info["a_now_page"]) {
    use_page_num = textbook_use_info["a_now_page"];
  }
  
  return (
    <div className="text-center">
      {!strFunc.is_empty(a_book_pdf_url) &&
        <button className="btn-s btn-gray"
          onClick={() => {
            let pdf_v_url = process.env.REACT_APP_API_URL + "/home/util/pdf_viewr";
            pdf_v_url += "?pdf_url=" + a_book_pdf_url + "&page=" + use_page_num;
            window.open(pdf_v_url);
          }}
          title={use_page_num + ""}>P.{strFunc.str_pad({ "str": use_page_num, "pad_length": 3 })}</button>
      }
    </div>
  );
};
export default StudyTitleAswer;